<template>
  <div class="bienvenida-page">
    <!-- Fondo fijo -->
    <div class="background-fixed"></div>

    <!-- Capa blanca encima del fondo -->
    <div class="white-overlay"></div>

    <!-- Ornamentos animados superiores -->
   
    <div class="ubicacion-linea">
      <div ref="lineaDecorativa" class="linea-decorativa"></div>
    </div>

    <!-- Contenido -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <!-- Texto de bienvenida -->
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>

        <!-- Nombre decorativo con flores laterales -->
        <div class="nombre-con-flores">
          <img src="@/assets/elementos2.png" alt="Flor izquierda" class="flor-lateral izquierda" />
          <div class="nuevo-texto" ref="nombreRef">
            Montserrat S
            <span class="e-wrapper">
              <span class="e-con-acento">a</span>
              <span class="falso-acento">´</span>
            </span>
            nchez Muro
          </div>          <img src="@/assets/elementos2.png" alt="Flor derecha" class="flor-lateral derecha" />
        </div>

        <!-- Agradecimiento a los padres -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref("Hace 15 años abrí los ojos y vi un mundo lleno de magia, pero me encontré sin amigos, sin sueños, sin nada. \n\nHoy tengo el honor de contar con familia y amigos, personas tan bellas que llenan mis días de luz. \n\nSu presencia ayudará a transformar mi noche inolvidable en el día más importante de mi vida.");

    const mensajeRef = ref(null);
    const nombreRef = ref(null);
    const agradecimientoRef = ref(null);
    const ornamentoIzq = ref(null);
    const ornamentoDer = ref(null);

    const animateOnScroll = (element, animation) => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animation();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      observer.observe(element);
    };

    onMounted(() => {
      if (mensajeRef.value) {
        animateOnScroll(mensajeRef.value, () => {
          gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 }, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            delay: 0.2,
            ease: 'power3.out'
          });
        });
      }

      if (nombreRef.value) {
        animateOnScroll(nombreRef.value, () => {
          gsap.fromTo(nombreRef.value, { opacity: 0, y: 30 }, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0.4,
            ease: 'power2.out'
          });
        });
      }

      if (agradecimientoRef.value) {
        animateOnScroll(agradecimientoRef.value, () => {
          gsap.fromTo(agradecimientoRef.value, { opacity: 0, y: 30 }, {
            opacity: 1,
            y: 0,
            duration: 1.2,
            delay: 0.5,
            ease: 'power2.out'
          });
        });
      }

      if (ornamentoIzq.value) {
        animateOnScroll(ornamentoIzq.value, () => {
          gsap.fromTo(ornamentoIzq.value, { opacity: 0, x: -100 }, {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: 'power3.out'
          });
        });
      }

      if (ornamentoDer.value) {
        animateOnScroll(ornamentoDer.value, () => {
          gsap.fromTo(ornamentoDer.value, { opacity: 0, x: 100 }, {
            opacity: 1,
            x: 0,
            duration: 1.2,
            ease: 'power3.out'
          });
        });
      }
    });

    return {
      mensaje,
      mensajeRef,
      nombreRef,
      agradecimientoRef,
      ornamentoIzq,
      ornamentoDer
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 0;
  margin-top:50px;
  margin-bottom: 50px;
}

.background-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/fondito.avif');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -3;
}

.white-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.50);
  z-index: -2;
}

.animated-ornamento {
  position: absolute;
  top: 80px;
  width: 90px;
  height: auto;
  opacity: 0;
  z-index: 1;
}

.ornamento-left {
  left: 20px;
}

.ornamento-right {
  right: 20px;
}

.bienvenida-container {
  position: relative;
  width: 100%;
  min-height: auto;
  padding: 40px 20px 20px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1;
}

.contenido-bienvenida {
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.mensaje-bienvenida {
  font-size: 19px;
  font-weight: 300;
  font-family: 'Josefin Sans', sans-serif;
  color: #28303e;
  white-space: pre-line;
  line-height: 2;
  margin-bottom: 20px;
  opacity: 0;
}

.mensaje-bienvenida:hover {
  color: rgba(122, 101, 97, 0.8);
}

.nombre-con-flores {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 10px;
}

.flor-lateral {
  width: 40px;
  height: auto;
  opacity: 0.95;
}






.nuevo-texto {
  font-size: 22px;
  font-family: 'FeelingPassionate';
  color: #c6949b;
  line-height: 2.4;
  
  opacity: 0;
  position: relative;
}

.e-wrapper {
  position: relative;
  letter-spacing: -0.35em;
  display: inline-block;
  margin: 0;                   /* ← quita cualquier margen lateral */
  padding: 0;                  /* ← quita relleno lateral */
}

.e-con-acento {
  color: #c6949b;
  letter-spacing: -0.25em;
  position: relative;
  margin-left: -2px;
  padding: 0;
}

.falso-acento {
  position: absolute;
  top: 10px;
  left: 0em;         /* 🔧 Reducido un poco para acercarlo más */
  font-size: 0.45em;     /* 🔧 Más pequeño que antes */
  font-weight: normal;
  color: #c6949b;
  z-index: 5;
  transform: rotate(15deg);
  pointer-events: none;
}

.agradecimiento {
  font-size: 20px;
  font-family: 'Dancing Script', cursive;
  color: #7a6a65;
  line-height: 1.8;
  opacity: 0;
  margin-top: 10px;
}

.nombre-padre,
.nombre-madre {
  font-family: 'Dancing Script', cursive;
  font-size: 19px;
  color: #5e4b47;
}

.ampersand {
  font-size: 22px;
  color: #b29b95;
  font-family: serif;
}
</style>
